export default function () {
  return Math.round(this._scaling * this._rotatedInternalImageWidth)
}
